import React from 'react';
import { Box, Typography } from '@mui/material';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(() => ({
    capitalize: {
        textTransform: 'capitalize'
    }
}));
const Title = (props) => {
    const classes = useStyles();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                p: props.px ? (0.5, 1) : props.px,
                m:'0px 0px 16px 0px'
                //pb: 1,
            }}>
            {props.addicon ? (
                props.addicon == 'takeoff' ? (
                    <FlightTakeoffIcon color="primary" />
                ) : (
                    <FlightLandIcon color="primary" />
                )
            ) : null}
            <Typography
                variant="h4"
                flexGrow={1}
                fontSize={props.header?40:35}
                fontWeight={700}
                fontFamily={'Action NBA'}
                noWrap 
                fontStyle="normal"
                letterSpacing={"2.5px"}
                color='primary'
                component="div"
                className={classes.capitalize} 
                {...props}>
                {props.title}
            </Typography>
        </Box>
    );
};
export default Title;
